import clsx from 'clsx';
import styles from './ModeToggleSwitch.module.css';
import { Switch, Box, Typography } from '@mui/material';
import { connect } from 'react-redux';
import { DARK_MODE } from '../../constants';
import { Palette } from '@mui/icons-material';

const mapStateToProps = state => {
  return {
    mode: state.theme,
  };
};

const ModeToggleSwitch = ({
  handleSwitch,
  isSwitchEnabled = false,
  switchLabel,
  mode
}) => {
    const {themeMode} = mode;
    const isDark = themeMode === DARK_MODE;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '8px 12px',
        background: isDark 
          ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)'
          : 'linear-gradient(135deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.02) 100%)',
        borderRadius: '8px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(8px)',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Typography
        sx={{
          color: isDark ? 'rgba(255, 255, 255, 0.9)' : 'rgba(0, 0, 0, 0.8)',
          fontWeight: 500,
          fontSize: '13px',
          letterSpacing: '0.3px',
          whiteSpace: 'nowrap'
        }}
      >
        {switchLabel}
      </Typography>
      <Switch
        sx={{
          '& .MuiSwitch-root': {
            width: 44,
            height: 24,
            padding: 0,
          },
          '& .MuiSwitch-switchBase': {
            padding: 1,
            '&.Mui-checked': {
              transform: 'translateX(20px)',
              '& + .MuiSwitch-track': {
                backgroundColor: isDark ? '#4CAF50' : '#2196F3',
                opacity: 1,
              },
              '& .MuiSwitch-thumb': {
                backgroundColor: '#ffffff',
                boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
              },
            },
          },
          '& .MuiSwitch-thumb': {
            width: 20,
            height: 20,
            backgroundColor: '#ffffff',
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
            transition: 'all 0.2s ease',
          },
          '& .MuiSwitch-track': {
            borderRadius: 12,
            backgroundColor: isDark ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)',
            opacity: 1,
            transition: 'all 0.2s ease',
          },
          '&:hover .MuiSwitch-thumb': {
            boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.3)',
            transform: 'scale(1.05)',
          },
        }}
        checked={isSwitchEnabled}
        onChange={handleSwitch}
        color='default'
        inputProps={{ 'aria-label': 'mode toggle switch' }}
      />
    </Box>
  );
};

export default connect(mapStateToProps, null)(ModeToggleSwitch);